import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import { useDispatch } from 'react-redux'
import { updateFragmentValue } from 'actions/powerTakeOff'

import { fragmentConfigurationSchema } from 'schemas/validation/fragment'
import { schemaProp } from 'schemas/validation'
import strings from 'utils/strings'
import { FragmentWarningIconStyled } from 'components/patterns/Icon/IconsStyled'
import { StyledDynamicInput, StyledWarningMessage } from './SingleEditor.style'

const rule = schemaProp(fragmentConfigurationSchema)

const SingleEditor = ({ fragment, readOnly, updateValue, disabled }) => {
  const dispatch = useDispatch()
  const {
    name,
    refNo,
    configuration: {
      units,
      value,
      type,
      definedValues = [],
      translations,
      originalValue,
    } = {},
    isEcfFragmentOutOfRange,
    description,
    moduleNo,
  } = fragment || {}

  const handleChange = useCallback(
    (newValue) => dispatch(updateValue(refNo, newValue)),
    [refNo, dispatch, updateValue]
  )

  if (!type) return null

  return (
    <StyledDynamicInput
      refNo={refNo}
      name={name}
      units={units}
      value={value}
      description={description}
      moduleNo={moduleNo}
      type={type}
      definedValues={definedValues}
      translations={translations}
      onChange={handleChange}
      makeLabel={() => (units ? `${name} ${units}` : name)}
      rules={rule('value', {
        definedValues: [...definedValues, originalValue],
      })}
      hideClosestValues={value === originalValue}
      hideErrorWhenDefault={value === originalValue}
      readOnly={readOnly}
      disabled={disabled}
    >
      {isEcfFragmentOutOfRange && (
        <StyledWarningMessage>
          <div>
            <FragmentWarningIconStyled />
          </div>
          <span>
            {strings.pto_default_fragment_value_warning(originalValue, units)}
          </span>
        </StyledWarningMessage>
      )}
    </StyledDynamicInput>
  )
}

SingleEditor.defaultProps = {
  updateValue: updateFragmentValue,
}

SingleEditor.propTypes = {
  readOnly: PropTypes.bool,
  updateValue: PropTypes.func,
  disabled: PropTypes.bool,
  fragment: PropTypes.shape({
    name: PropTypes.string,
    refNo: PropTypes.string,
    domain: PropTypes.string,
    isEcfFragmentOutOfRange: PropTypes.bool,
    configuration: PropTypes.shape({
      units: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
      ]),
      definedValues: PropTypes.array,
      type: PropTypes.string,
      translations: PropTypes.array,
    }),
    moduleNo: PropTypes.string,
    description: PropTypes.string,
  }),
}

export default SingleEditor
